import React, { Component } from 'react';
import {
  View,
  TouchableWithoutFeedback,
  UIManager,
  LayoutAnimation,
  Animated,
  Platform,
  Easing,
} from 'react-native';

import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import PropTypes from 'prop-types';

import FoundationTestKeys from '../../../FoundationTestKeys';
import BlinkView from '../../AnimationView/BlinkView';
import { Icon } from '../../Icon';
import { withTheme, LightThemeColors, getThemeImages } from '../../Themes';
import Colors from '../../Themes/Colors';
import { Types } from '../../Themes/Types';
import { AnimatedVFText } from '../../VFText';

import styles from './CollapsibleItem.Styles';

const CustomLayoutAnimation = {
  duration: 200,
  create: {
    type: LayoutAnimation.Types.linear,
    property: LayoutAnimation.Properties.opacity,
  },
  update: {
    type: LayoutAnimation.Types.easeInEaseOut,
  },
  delete: {
    duration: 50,
    type: LayoutAnimation.Types.linear,
    property: LayoutAnimation.Properties.opacity,
  },
};

class CollapsibleItem extends Component {
  constructor(props) {
    super(props);
    const initTransmissionValue = props.type === Types.PRIMARY ? 1 : 0;
    this.state = {
      isOpend: props.isOpend,
      animatedIcon: new Animated.Value(0),
      transmissionAnimation: new Animated.Value(initTransmissionValue),
    };
    if (Platform.OS === 'android' && UIManager.setLayoutAnimationEnabledExperimental) {
      UIManager.setLayoutAnimationEnabledExperimental(true);
    }
  }

  static getDerivedStateFromProps(props, state) {
    if (props.isOpend !== state.isOpend) {
      LayoutAnimation.configureNext(CustomLayoutAnimation);
      Animated.timing(state.animatedIcon, {
        toValue: props.isOpend ? 1 : 0,
        duration: 200,
        easing: Easing.linear,
        useNativeDriver: false,
      }).start();
      return {
        isOpend: props.isOpend,
      };
    }

    return null;
  }

  componentDidUpdate(prevProps) {
    const { transmissionAnimation } = this.state;
    if (prevProps.type !== this.props.type) {
      Animated.timing(transmissionAnimation, {
        toValue: this.props.type === Types.PRIMARY ? 1 : 0,
        duration: 500,
        useNativeDriver: false,
      }).start();
    }
  }
  render() {
    const {
      title,
      icon,
      content,
      type,
      isLastItem,
      disabled,
      isOpend,
      onPress,
      isBlinking,
      status,
      iconTestID,
      iconAccessibilityLabel,
      theme,
      collapsibleItemContainerStyle,
    } = this.props;
    const Images = getThemeImages(theme.name);
    const { animatedIcon, transmissionAnimation } = this.state;
    const isPrimary = type === Types.PRIMARY;
    const openColseIcon = Images.TImages.ic_chevron_down[type];

    const iconStyle = isPrimary ? {} : styles.iconSecondery;
    const spin = animatedIcon.interpolate({
      inputRange: [0, 1],
      outputRange: ['0deg', '-180deg'],
    });
    const itemColor = type === 'primary' ? theme.colors.textColor : Colors.white;
    const itemIconChange = transmissionAnimation.interpolate({
      inputRange: [0, 0.85, 1],
      outputRange: [Colors.white, itemColor, theme.colors.textColor],
    });

    const dividerColor = transmissionAnimation.interpolate({
      inputRange: [0, 1],
      outputRange: [theme.colors.VFDivider.secondary, theme.colors.VFDivider.tertiary],
    });

    return (
      <Animated.View
        style={[
          styles.container(theme, type),
          { borderColor: dividerColor },
          isLastItem ? styles.borderBottom : undefined,
          collapsibleItemContainerStyle,
        ]}
        accessibilityLabel={FoundationTestKeys.checkItemLayout}
        testID={FoundationTestKeys.checkItemLayout}
      >
        <TouchableWithoutFeedback
          onPress={onPress}
          disabled={disabled}
          accessible={false}
          testID={FoundationTestKeys.collapsibleItemTWF}
        >
          <View
            style={styles.headdingContainer}
            testID={FoundationTestKeys.collapsibleItemContainerView}
          >
            <View style={styles.textWithIcon} testID={FoundationTestKeys.collapsibleItemTextView}>
              <BlinkView disabled={!isBlinking}>
                <Icon
                  type="animatedImage"
                  name={icon}
                  size={32}
                  style={[
                    iconStyle,
                    { tintColor: itemIconChange },
                    status === 2 ? styles.opacityStyle : null,
                  ]}
                  testID={iconTestID}
                  accessibilityLabel={iconAccessibilityLabel}
                />
              </BlinkView>
              <AnimatedVFText
                style={[styles.headdingText, { color: itemIconChange }]}
                testKey={FoundationTestKeys.checkItemTitle}
                i18nKey={title}
              />
            </View>

            <Animated.View
              style={{
                transform: [{ rotate: spin }, { perspective: 1000 }],
              }}
              accessibilityLabel={`${!isNaN(isOpend)}`}
              testID={FoundationTestKeys.EIODetailsArrow}
            >
              <Icon type="image" name={openColseIcon} size={32} />
            </Animated.View>
          </View>
        </TouchableWithoutFeedback>
        <TouchableWithoutFeedback
          accessible={false}
          testID={FoundationTestKeys.collapsibleItemNotAccessibleTWF}
        >
          {isOpend ? (
            <View
              style={styles.contentContainer}
              testID={FoundationTestKeys.collapsibleItemNotAccessibleTWFView}
            >
              {content}
            </View>
          ) : (
            <View testID={FoundationTestKeys.collapsibleItemNotAccessibleTWFEmptyView} />
          )}
        </TouchableWithoutFeedback>
      </Animated.View>
    );
  }
}

CollapsibleItem.propTypes = {
  title: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({ uri: PropTypes.string })]),
  iconTestID: PropTypes.string,
  iconAccessibilityLabel: PropTypes.string,
  content: PropTypes.any,
  status: PropTypes.any,
  type: PropTypes.oneOf([Types.PRIMARY, Types.SECONDARY]),
  onClick: PropTypes.func,
  isLastItem: PropTypes.bool,
  disabled: PropTypes.bool,
  isOpend: PropTypes.number,
  onPress: PropTypes.func,
  isBlinking: PropTypes.bool,
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
  collapsibleItemContainerStyle: ViewPropTypes.style,
};

CollapsibleItem.defaultProps = {
  disabled: false,
  isBlinking: false,
  theme: LightThemeColors,
};

export default withTheme(CollapsibleItem);
